import { render, staticRenderFns } from "./FluxoVendas.vue?vue&type=template&id=252ceb22&scoped=true"
import script from "./FluxoVendas.vue?vue&type=script&lang=js"
export * from "./FluxoVendas.vue?vue&type=script&lang=js"
import style0 from "./FluxoVendas.vue?vue&type=style&index=0&id=252ceb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ceb22",
  null
  
)

export default component.exports